import { z } from 'zod';

import { makeEndpoint } from '../common';

// Define the schema for AuthenticateResponse
const AuthenticateResponseSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number(),
  tokenType: z.string(),
  clientId: z.string(),
});

// Define the schema for AuthenticateRequest
const AuthenticateRequestSchema = z.object({
  code: z.string(),
  redirectUrl: z.string(),
});

export const AuthenticateEndpoint = makeEndpoint({
  method: 'POST',
  url: () => 'hyatt/authenticate',
  responseSchema: AuthenticateResponseSchema,
  requestSchema: AuthenticateRequestSchema,
});
